import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TabBar } from './TabBar';
import { Header } from './Header';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { OfflineToast } from '@/components/OfflineToast';
import { KeyboardShortcuts } from '@/components/KeyboardShortcuts';

// Top-level layout. On desktop (lg+): sidebar + content. On mobile: header sticky
// at top, content scrolls, tab bar pinned to bottom with iOS safe-area padding.
export function AppShell() {
  const location = useLocation();
  return (
    <div className="min-h-screen flex bg-bg text-text">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 overflow-y-auto pb-24 lg:pb-6 scroll">
          {/* resetKey = pathname so route changes clear any prior error */}
          <ErrorBoundary resetKey={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </main>
        <TabBar />
      </div>
      <OfflineToast />
      <KeyboardShortcuts />
    </div>
  );
}
